// This file is used to handle some common items in myhoover.

(function ($) {
  $(function () {
    function handleCheckbox(pageTargetId) {
      $(document).on('change', '.myhoover ' + pageTargetId + ' .col-four-card input.myhoover-fellow-checkbox', function () {
        let thisDataId = this.getAttribute('data-id'), thisDataName = this.getAttribute('data-name'), thisFeaturedImage = this.closest('.content').querySelector('.myhoover-fellow-img img').getAttribute('src'),
          fellowPosition = this.closest('.content').querySelector('.myhoover-fellow-position').textContent;
        if (this.checked == true) {
          if (!$('.fellow-wrapper input[data-id="'+thisDataId+'"]').length > 0) {
            appendCurrentFellows(pageTargetId, thisDataName, thisDataId, thisFeaturedImage,fellowPosition );
          }
        } else {
          if ($('.fellow-wrapper input[data-id="'+thisDataId+'"]').length > 0) {
            removeCurrentFellows(pageTargetId, thisDataId);
          }
        }

        if ($('.fellow-wrapper .fellow-card').length > 0) {
          $(pageTargetId + ' .myhoover-current-fellow').show(500);
          $('.myhoover ' + pageTargetId + ' .clear-btn').show();
        } else {
          $('.myhoover ' + pageTargetId + ' .clear-btn').hide();
          $(pageTargetId + ' .myhoover-current-fellow').hide(500);
        }
      });
    }

    function crossBtnClick(pageId) {
      $(document).on('click', '.myhoover ' + pageId + ' .fellow-wrapper .fellow-card .check-box-wrap label.checked', function () {
        const thisTagText = $(this).siblings('input.red-checkbox').attr('data-id');
        $(this).closest('.fellow-card').remove();
        $('.myhoover ' + pageId + ' .col-four-card .check-box-wrap input[data-id="'+thisTagText+'"]').eq(0).trigger('click');
      });
    }

    function clearAllTags(pageId) {
      $('.myhoover ' + pageId + ' .clear-btn').on('click', function () {
        $(pageId +' .fellow-wrapper').empty();
        $('.myhoover ' + pageId + ' #hits .col-four-card .check-box-wrap input:checkbox:checked').trigger('click');
        if ($('.fellow-wrapper').find('.fellow-card').length == 0) {
          $(this).closest('.clear-btn').hide();
        }
      });
    }

    function appendCurrentFellows(pageId, tagText, tagId, featuredImage, position) {
      const htmlString = '<div class="fellow-card">' +
        '              <div class="fellow-image">' +
        '                <img src="'+featuredImage+'" alt="Image">' +
        '            </div>' +
        '            <div class="content">' +
        '            <div class="check-box-wrap">' +
        '              <input type="checkbox" data-id="'+ tagId +'" class="red-checkbox" checked>' +
        '              <label class="checked">Remember Me</label>' +
        '            </div>' +
        '            <div class="fellow-title">' +
        '              <h6>'+tagText+'</h6>' +
        '              <span>'+ position +'</span>' +
        '            </div>' +
        '              </div>' +
        '            </div>';
      $('.myhoover ' + pageId + ' .fellow-wrapper').append(htmlString);
    }

    function removeCurrentFellows(pageId, tagId) {
      if ($('.myhoover ' + pageId + '.my-feed-settings .fellow-wrapper .fellow-card input[data-id="'+tagId+'"]').length > 0) {
        $('.myhoover ' + pageId + '.my-feed-settings .fellow-wrapper .fellow-card input[data-id="'+tagId+'"]').closest('.fellow-card').remove();
      }
    }

    function fellowSelectHandler(elementTarget) {
      $(document).on('change', elementTarget, function (){
        var dataId = $(this).attr('data-id');
        if($(this).is(":checked")) {
          $(elementTarget+'[data-id='+dataId+']').prop('checked', true);
        } else {
          $(elementTarget+'[data-id='+dataId+']').prop('checked', false);
        }
      });
    }
    if ($('#myhoover-signup-fellows').length > 0) {
      fellowSelectHandler('.myhoover #myhoover-signup-fellows .myhoover-fellow-card .check-box-wrap input');
    }
    if ($('#myhoover-fellows').length > 0) {
      crossBtnClick('#myhoover-fellows');
      clearAllTags('#myhoover-fellows');
      handleCheckbox('#myhoover-fellows');
      fellowSelectHandler('.myhoover #myhoover-fellows .col-four-card .check-box-wrap input');
    }
  });
})(jQuery);
